module.exports = {
	ArgumentError: require("./ArgumentError").default,
	EOFError: require("./EOFError").default,
	Error: require("./Error").default,
	IllegalOperationError: require("./IllegalOperationError").default,
	IOError: require("./IOError").default,
	RangeError: require("./RangeError").default,
	SecurityError: require("./SecurityError").default,
	TypeError: require("./TypeError").default,
}